import React, { useEffect, useState } from "react";
import { fetchData, S3_BASE_URL } from "../../Service";
import SectionTitle from "../../components/Common/SectionTitle";
import SingleService from "../../components/Service/SingleService";
import Loader from "../../Loader";
import he from "he";

const Service = () => {
  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(true);

  useEffect(() => {
    const getServices = async () => {
      try {
        const response = await fetchData("/api/v1/service");

        // Check if response has success status and valid data
        if (response?.success && response?.data) {
          const formattedServices = response.data.map((service) => ({
            ...service,
            serviceImage: service.serviceImage
              ? `${S3_BASE_URL}/${service.serviceImage}`
              : "",
          }));
          setServices(formattedServices);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoadingServices(false);
      }
    };

    getServices();
  }, []);

  return (
    <div
      id="rs-service"
      className="rs-services main-home gray-bg pt-110 pb-120 md-pt-70 md-pb-70"
    >
      <div className="container">
        <SectionTitle
          sectionClass="sec-title2 text-center mb-46"
          subtitleClass="sub-text"
          subtitle="Services"
          titleClass="title"
          title="We Are Offering All Kinds of IT Solutions Services"
          effectClass="heading-line"
        />
        <div className="row">
          {loadingServices ? (
            <Loader />
          ) : services.length > 0 ? (
            services.map((service) => (
              <div key={service._id} className="col-lg-4 col-md-6 mb-30">
                <SingleService
                  itemClass="services-item"
                  serviceImage={service.serviceImage}
                  serviceURL={service.serviceURL || "#"}
                  Title={he.decode(service.title)}
                  Text={he.decode(service.description).replace(/<\/?p>/gi, "")}
                />
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <p>No services available at the moment.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Service;
